import { render, staticRenderFns } from "./TableArea.vue?vue&type=template&id=f3bef3ca&scoped=true&"
import script from "./TableArea.vue?vue&type=script&lang=js&"
export * from "./TableArea.vue?vue&type=script&lang=js&"
import style0 from "./TableArea.vue?vue&type=style&index=0&id=f3bef3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bef3ca",
  null
  
)

export default component.exports